import { CustomizationType } from "@/services/lhApi/enum";

export interface SEOrderParsedCustomizationInfo {
    pic: string;

    ossUrl?: string;

    effectPic: string;

    brand?: string;

    model?: string;

    material?: string;

    bgColorName?: string;

    // 通用定制品名称
    bottomPanelName?: string;

    // 定制面名称
    aspectName?: string;

    quantity: number;

    customizationType?: CustomizationType;
}

export interface SEOrderParsedCustomization {
    /**来火定制信息id */
    id: number;

    version: string;

    customizations: SEOrderParsedCustomizationInfo[];
}

export enum CustomizationInfoType {
    /**
     * 来自淘宝的来火定制定制
     */
    CUSTOMIZATION = "CUSTOMIZATION",
    /**
     * 来自h5定制
     */
    H5 = "H5",
}

interface CustomizationInfoDTO {
    id: number;

    /**
     * json 解析之后为
     * @see SEOrderParsedCustomization
     */
    content: string;

    customizationFeePaid?: boolean;

    type?: CustomizationInfoType;

    new: boolean;
}

export enum ParsedCustomizationType {
    /**
     * 新版手机壳定制
     */
    PHONE_CASE_CUSTOMIZATION_V2 = "PHONE_CASE_CUSTOMIZATION_V2",

    /**
     * 旧版来火定制
     */
    LH_CUSTOMIZATION_V1 = "LH_CUSTOMIZATION_V1",

    /**
     * 未知
     */
    UNKNOWN = "UNKNOWN",
}

export interface PhoneCaseCustomizationInfo {
    phoneBrandId: number;
    phoneBrandName: string;
    phoneModelId: number;
    phoneModelName: string;
    phoneCaseMaterialId: number;
    phoneCaseMaterialName: string;
    phoneCaseMaterialColorId: number;
    phoneCaseMaterialColorName: string;

    /**
     * 定制图文件ID
     */
    customizedImageFileId?: number;
    /**
     * 定制图URL
     */
    customizedImageUrl?: string;
    /**
     * 预览图文件ID，如果有预览图URL，必须要有预览图文件ID，后端需要校验文件真实性等操作
     */
    previewImageFileId: number;
    /**
     * 预览图URL
     */
    previewImageUrl: string;
}

export type ParsedResult =
    | {
          type: ParsedCustomizationType.PHONE_CASE_CUSTOMIZATION_V2;
          phoneCaseCustomizationInfos: PhoneCaseCustomizationInfo[];
      }
    | {
          type: ParsedCustomizationType.LH_CUSTOMIZATION_V1;
          customizationInfos: SEOrderParsedCustomizationInfo[];
      }
    | {
          type: ParsedCustomizationType.UNKNOWN;
      };

/**
 * 解析
 */
export function parseOrderItemCustomizationContent(content?: string): ParsedResult {
    if (!content) {
        return {
            type: ParsedCustomizationType.UNKNOWN,
        };
    }

    const customizationInfos: SEOrderParsedCustomizationInfo[] = [];

    try {
        const customization = JSON.parse(content);

        // 如果包含这样的结果
        if (customization && customization?.["v"] && customization?.["phoneCaseCustomizationInfos"]) {
            return {
                type: ParsedCustomizationType.PHONE_CASE_CUSTOMIZATION_V2,
                phoneCaseCustomizationInfos: customization?.phoneCaseCustomizationInfos as PhoneCaseCustomizationInfo[],
            };
        }

        // 如果有 id,则是来自淘宝或者h5的来火定制的定制信息
        if (!!customization?.id || customization?.customizations?.length) {
            customization?.customizations?.forEach((info) => {
                customizationInfos.push(info);
            });
        }
        // 如果是小程序的通用定制信息
        else if (Array.isArray(customization)) {
            customization.map((it) => {
                if (Array.isArray(it?.aspectInfos)) {
                    it?.aspectInfos?.forEach((aspectInfo) => {
                        const info: SEOrderParsedCustomizationInfo = {
                            pic: aspectInfo.customizeImageUrl,
                            effectPic: aspectInfo.resultImageUrl,
                            quantity: it.quantity,
                            bottomPanelName: it.bottomPanelName,
                            aspectName: aspectInfo.aspectName,
                            customizationType: CustomizationType.COMMON_CUSTOMIZATION,
                        };

                        customizationInfos.push(info);
                    });
                }
            });
        }
    } catch (error) {}

    if (customizationInfos.length) {
        return {
            type: ParsedCustomizationType.LH_CUSTOMIZATION_V1,
            customizationInfos,
        };
    }

    return {
        type: ParsedCustomizationType.UNKNOWN,
    };
}

export default CustomizationInfoDTO;
